import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

import {ConnectionType} from '@/model/network/connection/ConnectionType';
import {Metered} from '@/model/network/settings/Metered';

@jsonObject
export class ConnectionSettings {

  @jsonMember({name: 'id'})
  public Id!: string;

  @jsonMember({name: 'uuid'})
  public Uuid!: string;

  @jsonMember({name: 'authRetries'})
  public AuthRetries!: number;

  @jsonMember({name: 'autoConnect'})
  public AutoConnect!: boolean;

  @jsonMember({name: 'autoConnectPriority'})
  public AutoConnectPriority!: number;

  @jsonMember({name: 'autoConnectRetries'})
  public AutoConnectRetries!: number;

  @jsonMember({name: 'autoConnectSlaves'})
  public AutoConnectSlaves!: number;

  @jsonMember({name: 'gatewayPingTimeout'})
  public GatewayPingTimeout!: number;

  @jsonMember({name: 'interfaceName'})
  public InterfaceName!: string;

  @jsonMember({name: 'lldp'})
  public Lldp!: number;

  @jsonMember({name: 'llmnr'})
  public Llmnr!: number;

  @jsonMember({name: 'master'})
  public Master!: string;

  @jsonMember({name: 'mdns'})
  public Mdns!: number;

  @jsonMember({name: 'metered', constructor: Number})
  public Metered!: Metered;

  @jsonMember({name: 'multiConnect'})
  public MultiConnect!: number;

  @jsonArrayMember(String, {name: 'permissions'})
  public Permissions!: string[];

  @jsonMember({name: 'readOnly'})
  public ReadOnly!: boolean;

  @jsonArrayMember(String, {name: 'secondaries'})
  public Secondaries!: string[];

  @jsonMember({name: 'slaveType'})
  public SlaveType!: string;

  @jsonMember({name: 'stableId'})
  public StableId!: string;

  @jsonMember({name: 'timestamp'})
  public Timestamp!: number;

  @jsonMember({name: 'type', constructor: String})
  public Type!: ConnectionType;

  @jsonMember({name: 'waitDeviceTimeout'})
  public WaitDeviceTimeout!: number;

  @jsonMember({name: 'zone'})
  public Zone!: string;

  constructor(connectionSettings?: ConnectionSettings) {
    if (connectionSettings) {
      Object.assign(this, connectionSettings);

      if (connectionSettings.Secondaries) {
        this.Secondaries = JSON.parse(JSON.stringify(connectionSettings.Secondaries));
      }
    }
  }

  public get AutoConnectRetriesText(): string {
    switch (this.AutoConnectRetries) {
      case 0:
        return 'Retry forever';

      case 1:
        return 'No retry';

      case -1:
        return '4 retries (default)';

      default:
        return `${this.AutoConnectRetries} retries`;
    }
  }
}
